module.exports = {
  baseAPIURL: "https://api.dev.dentity.com",
  prefix: 'core/api/v1',
  dialCode: "+1",
  BASE_IMG_URL: 'https://hll-dev-main-bucket.s3.amazonaws.com',
  CDN_LINK: 'https://cdn.dev.dentity.com/static/popup/v1',
  baseUrlSocket: "https://socket.dev.dentity.com/",
}
